import { Hide } from 'components/Hide';
import { colors } from 'theme';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function PageHeaderSeparator(props: any) {
  return (
    <Hide
      xs
      sm
      md
      width="1px"
      height={20}
      bg={colors.elementGrey}
      opacity="0.5"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
